import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { ReactUINodes } from 'common/enums/common.js';
import { KnowEdmTableData } from '../table-enums.js';
import { KnowEdmTableValue } from '../../interfaces.js';
import { TieOnTypes } from '../enums.js';

const surveyRunAssociatedDataMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

surveyRunAssociatedDataMap.set(KnowEdmTableData.SurveyRunName, {
  key: KnowEdmTableData.SurveyRunName,
  label: RecognisedHeaderLabels.SurveyRunName,
  unit: '',
  quantity: '',
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.IPMFile, {
  key: KnowEdmTableData.IPMFile,
  label: RecognisedHeaderLabels.IPMFile,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.tieType, {
  key: KnowEdmTableData.tieType,
  label: RecognisedHeaderLabels.TieOn,
  unit: '',
  quantity: '',
  options: Object.values(TieOnTypes).map((i) => ({ label: i, value: i })),
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.tieOnRun, {
  key: KnowEdmTableData.tieOnRun,
  label: RecognisedHeaderLabels.TieOnRun,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.GeomagneticParametersDefinition, {
  key: KnowEdmTableData.GeomagneticParametersDefinition,
  label: RecognisedHeaderLabels.GeomagneticParametersDefinition,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.HoleSize, {
  key: KnowEdmTableData.HoleSize,
  label: RecognisedHeaderLabels.HoleSize,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.CovarianceMatrix, {
  key: KnowEdmTableData.CovarianceMatrix,
  label: RecognisedHeaderLabels.CovarianceMatrix,
  unit: '',
  quantity: '',
  type: ReactUINodes.Select,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.IncOnly, {
  key: KnowEdmTableData.IncOnly,
  label: RecognisedHeaderLabels.IncOnly,
  unit: '',
  quantity: '',
  type: ReactUINodes.Toggle,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.DrillfloorHeight, {
  key: KnowEdmTableData.DrillfloorHeight,
  label: RecognisedHeaderLabels.DrillfloorHeight,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.GroundElevation, {
  key: KnowEdmTableData.GroundElevation,
  label: RecognisedHeaderLabels.GroundElevation,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.ExtrapolateToBit, {
  key: KnowEdmTableData.ExtrapolateToBit,
  label: RecognisedHeaderLabels.ExtrapolateToBit,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.DepthMD, {
  key: KnowEdmTableData.DepthMD,
  label: RecognisedHeaderLabels.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  locked: true,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  label: RecognisedHeaderLabels.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  locked: true,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  label: RecognisedHeaderLabels.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  locked: true,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.DepthTVD, {
  key: KnowEdmTableData.DepthTVD,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  locked: true,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.LocalPositionEW, {
  key: KnowEdmTableData.LocalPositionEW,
  label: RecognisedHeaderLabels.LocalPositionEW,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  locked: true,
});

surveyRunAssociatedDataMap.set(KnowEdmTableData.LocalPositionNS, {
  key: KnowEdmTableData.LocalPositionNS,
  label: RecognisedHeaderLabels.LocalPositionNS,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  locked: true,
});

export {
  surveyRunAssociatedDataMap,
};
